export default function PostRealEstateForm({
    formData,
    setFormData,
    projects = [],
    imageFiles = [],
    setImageFiles,
    uploading,
    handleChange,
    handleFileChange,
    handleRemoveImage,
    handleSubmit,
    errors
}) {
    const amenitiesList = [
        "Hồ bơi", "Gym", "Khu vui chơi", "Bảo vệ 24/7",
        "Bãi đỗ xe", "Thang máy", "Sân vườn", "BBQ",
        "Trung tâm thương mại", "Công viên", "Trường học"
    ];

    // Hàm tiện ích để chuẩn hóa className cho input
    const inputClass = "mt-1 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out";

    return (
        <div className="max-w-5xl mx-auto p-8 bg-gray-50 shadow-2xl rounded-xl mt-8">
            <div className="text-2xl font-serif font-bold tracking-widest uppercase">
                <span className="text-[#0c2c4d]">Đăng tin</span> <span className="text-[#c9a063]">mua - bán - cho thuê</span>
            </div>
            <form onSubmit={handleSubmit} className="space-y-8">

                {/* --- Phần 1: Thông Tin Chung và Dự Án --- */}
                <div className="p-6 bg-white rounded-xl shadow-md">
                    <h3 className="text-xl font-semibold mb-4 text-gray-700">1. Thông Tin Cơ Bản</h3>

                    {/* Dự án liên kết */}
                    <div className="mt-4">
                        <label className="block font-semibold text-gray-700 mb-1">
                            Tên dự án <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            name="projectName"
                            value={formData.projectName || ""}
                            onChange={(e) => {
                                const name = e.target.value;
                                const selectedProject = projects.find(p => p.name === name);
                                setFormData(prev => ({
                                    ...prev,
                                    projectName: name,
                                    projectId: selectedProject ? selectedProject.id : null
                                }));
                            }}
                            list="projectsList"
                            className={inputClass}
                            placeholder="Chọn hoặc nhập tên dự án"
                            required
                        />
                        <datalist id="projectsList">
                            {projects.map(p => (
                                <option key={p.id} value={p.name} />
                            ))}
                        </datalist>
                        {errors.projectName && <p className="text-red-500 text-sm mt-1">{errors.projectName}</p>}
                    </div>

                    {/* Tiêu đề & Loại BĐS */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                        <div>
                            <label className="block font-semibold text-gray-700 mb-1">Tiêu đề tin <span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                className={inputClass}
                                placeholder="Ví dụ: Căn hộ 2PN view đẹp, giá tốt nhất..."
                                required
                            />
                            {errors.title && <p className="text-red-500 text-sm mt-1">{errors.title}</p>}
                        </div>

                        <div>
                            <label className="block font-semibold text-gray-700 mb-1">Loại bất động sản <span className="text-red-500">*</span></label>
                            <select
                                name="propertyType"
                                value={formData.propertyType || ""}
                                onChange={handleChange}
                                className={inputClass}
                                required
                            >
                                <option value="" disabled>-- Chọn loại --</option>
                                <option value="apartment">Căn hộ</option>
                                <option value="villa">Biệt thự</option>
                                <option value="shophouse">Shophouse</option>
                                <option value="condotel">Condotel</option>
                                <option value="penthouse">Penthouse</option>
                                <option value="duplex">Duplex</option>
                            </select>
                            {errors.propertyType && <p className="text-red-500 text-sm mt-1">{errors.propertyType}</p>}
                        </div>
                    </div>

                    <div className="mt-4">
                        <label className="block font-semibold text-gray-700 mb-1">Loại giao dịch *</label>
                        <select
                            name="transactionType"
                            value={formData.transactionType || "sale"}
                            onChange={handleChange}
                            className={inputClass}
                        >
                            <option value="sale">Bán</option>
                            <option value="rent">Cho thuê</option>
                        </select>
                        {errors.transactionType && <p className="text-red-500 text-sm mt-1">{errors.transactionType}</p>}
                    </div>
                </div>

                {/* --- Phần 2: Chi Tiết Căn Hộ và Giá --- */}
                <div className="p-6 bg-white rounded-xl shadow-md">
                    <h3 className="text-xl font-semibold mb-4 text-gray-700">2. Chi Tiết và Định Giá</h3>

                    {/* Block, Mã căn, Tầng */}
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                        <div>
                            <label className="block font-medium text-gray-700">Block / Phân khu</label>
                            <input type="text" name="block" value={formData.block || ""} onChange={handleChange}
                                className={inputClass} placeholder="Ví dụ: B2 hoặc The River" />
                        </div>
                        <div>
                            <label className="block font-medium text-gray-700">Mã sản phẩm</label>
                            <input type="text" name="unitCode" value={formData.unitCode || ""} onChange={handleChange}
                                className={inputClass} placeholder="Ví dụ: B2-0501" />
                        </div>
                        <div>
                            <label className="block font-medium text-gray-700">Tầng</label>
                            <input type="number" name="floor" value={formData.floor || ""} onChange={handleChange}
                                className={inputClass} placeholder="Ví dụ: 5" />
                        </div>
                    </div>

                    {/* Phòng ngủ & WC */}
                    <div className="grid grid-cols-2 gap-4 mt-4">
                        <div>
                            <label className="block font-medium text-gray-700">Số phòng ngủ</label>
                            <input type="number" name="bedrooms" value={formData.bedrooms || ""}
                                onChange={handleChange} className={inputClass} placeholder="Ví dụ: 2" min="0" />
                        </div>
                        <div>
                            <label className="block font-medium text-gray-700">Số phòng WC</label>
                            <input type="number" name="bathrooms" value={formData.bathrooms || ""}
                                onChange={handleChange} className={inputClass} placeholder="Ví dụ: 2" min="0" />
                        </div>
                    </div>

                    {/* Diện tích & Giá */}
                    <div className="grid grid-cols-2 gap-4 mt-4">
                        <div>
                            <label className="block font-semibold text-gray-700 mb-1">Diện tích (m²) <span className="text-red-500">*</span></label>
                            <input type="number" name="area" value={formData.area || ""}
                                onChange={handleChange} className={inputClass} required placeholder="Ví dụ: 80" min="1" />
                        </div>
                        {/* Giá bán hoặc giá thuê */}
                        {formData.transactionType === "sale" ? (
                            <div>
                                <label className="block font-semibold text-gray-700">Giá bán (VND)</label>
                                <input type="number" name="price" value={formData.price || ""} onChange={handleChange} className={inputClass} placeholder="Ví dụ: 3000000000 (3 tỷ)" min="0" />
                                {errors.price && <p className="text-red-500 text-sm mt-1">{errors.price}</p>}
                            </div>
                        ) : (
                            <div>
                                <label className="block font-semibold text-gray-700">Giá thuê (VND)</label>
                                <input type="number" name="rentPrice" value={formData.rentPrice || ""} onChange={handleChange} className={inputClass} placeholder="Ví dụ: 20000000 (20 triệu)/tháng" min="0" />
                                {errors.rentPrice && <p className="text-red-500 text-sm mt-1">{errors.rentPrice}</p>}
                            </div>
                        )}
                    </div>
                </div>

                {/* --- Phần 3: Trạng Thái & Địa Chỉ --- */}
                <div className="p-6 bg-white rounded-xl shadow-md">
                    <h3 className="text-xl font-semibold mb-4 text-gray-700">3. Trạng Thái, Nội Thất & Vị Trí</h3>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        {/* Nội thất */}
                        <div>
                            <label className="block font-medium text-gray-700 mb-1">Tình trạng nội thất</label>
                            <select name="furniture" value={formData.furniture || "none"} onChange={handleChange}
                                className={inputClass}>
                                <option value="full">Đầy đủ (Full Furniture)</option>
                                <option value="basic">Cơ bản (Basic Furniture)</option>
                                <option value="none">Không có (Raw)</option>
                            </select>
                        </div>

                        {/* Trạng thái bàn giao */}
                        <div>
                            <label className="block font-medium text-gray-700 mb-1">Tình trạng bàn giao</label>
                            <select name="handoverStatus" value={formData.handoverStatus || "basic"} onChange={handleChange}
                                className={inputClass}>
                                <option value="raw">Thô</option>
                                <option value="basic">Hoàn thiện cơ bản</option>
                                <option value="furnished">Đầy đủ nội thất</option>
                            </select>
                        </div>

                        {/* Loại tin / Nguồn */}
                        <div>
                            <label className="block font-medium text-gray-700 mb-1">Nguồn tin</label>
                            <select name="isPrimary" value={formData.isPrimary ? "true" : "false"} onChange={(e) => {
                                setFormData(prev => ({ ...prev, isPrimary: e.target.value === "true" }));
                            }} className={inputClass}>
                                <option value="false">Ký gửi (Thứ cấp)</option>
                                <option value="true">Hàng chủ đầu tư (Sơ cấp)</option>
                            </select>
                        </div>
                    </div>

                    {/* Địa chỉ */}
                    <div className="mt-4">
                        <label className="block font-semibold text-gray-700 mb-1">Địa chỉ / Vị trí <span className="text-red-500">*</span></label>
                        <input type="text" name="location" value={formData.location || ""}
                            onChange={handleChange} className={inputClass} required placeholder="Số nhà, đường, quận/huyện, tỉnh/thành phố" />
                    </div>
                </div>
                {/* --- Phần phụ: View & Pháp lý --- */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                    <div>
                        <label className="block font-medium text-gray-700">Hướng view</label>
                        <input
                            type="text"
                            name="view"
                            value={formData.view || ""}
                            onChange={handleChange}
                            className={inputClass}
                            placeholder="Ví dụ: View sông, View hồ, View nội khu"
                        />
                    </div>
                    <div>
                        <label className="block font-medium text-gray-700">Tình trạng pháp lý</label>
                        <input
                            type="text"
                            name="legalStatus"
                            value={formData.legalStatus || "Sổ hồng lâu dài"}
                            onChange={handleChange}
                            className={inputClass}
                            placeholder="Ví dụ: Sổ hồng lâu dài, Hợp đồng mua bán"
                        />
                    </div>
                </div>

                {/* --- Phần 4: Tiện ích & Mô tả chi tiết --- */}
                <div className="p-6 bg-white rounded-xl shadow-md">
                    <h3 className="text-xl font-semibold mb-4 text-gray-700">4. Tiện Ích và Mô Tả</h3>

                    {/* Tiện ích */}
                    <div className="mb-6">
                        <label className="block font-medium text-gray-700 mb-2">Tiện ích</label>
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                            {amenitiesList.map((amenity) => (
                                <label key={amenity} className="flex items-center gap-2 bg-gray-100 p-2 rounded-lg cursor-pointer hover:bg-blue-50 transition duration-150 ease-in-out">
                                    <input
                                        type="checkbox"
                                        checked={formData.amenities?.includes(amenity)}
                                        onChange={() => {
                                            setFormData(prev => {
                                                const exists = prev.amenities?.includes(amenity);
                                                return {
                                                    ...prev,
                                                    amenities: exists
                                                        ? prev.amenities.filter(a => a !== amenity)
                                                        : [...(prev.amenities || []), amenity]
                                                };
                                            });
                                        }}
                                        className="form-checkbox text-blue-600 rounded"
                                    />
                                    <span className="text-sm text-gray-700">{amenity}</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    {/* Mô tả */}
                    <div>
                        <label className="block font-medium text-gray-700 mb-1">Mô tả chi tiết</label>
                        <textarea name="description" value={formData.description || ""}
                            onChange={handleChange} className={`${inputClass} h-32`} placeholder="Nêu bật các điểm mạnh, chính sách bán hàng và thông tin liên hệ." />
                    </div>
                </div>

                {/* --- Phần 5: Ảnh Bất Động Sản --- */}
                <div className="p-6 bg-white rounded-xl shadow-md">
                    <h3 className="text-xl font-semibold mb-4 text-gray-700">5. Hình Ảnh (Tối đa 10 ảnh)</h3>

                    <input type="file" multiple accept="image/*" onChange={handleFileChange}
                        className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" />

                    {imageFiles.length > 0 && (
                        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4 mt-4">
                            {imageFiles.map((file, i) => (
                                <div key={i} className="relative group overflow-hidden rounded-lg shadow-lg">
                                    <img
                                        src={URL.createObjectURL(file)}
                                        alt={`Bất động sản ${i + 1}`}
                                        className="w-full h-32 object-cover transition duration-300 group-hover:scale-105"
                                    />
                                    <button type="button" onClick={() => handleRemoveImage(i)}
                                        className="absolute top-1 right-1 bg-red-600 text-white p-1 rounded-full opacity-90 hover:opacity-100 transition duration-150 ease-in-out">
                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* --- Submit --- */}
                <button type="submit"
                    className="w-full bg-blue-600 text-white font-bold text-lg px-6 py-3 rounded-xl shadow-lg hover:bg-blue-700 transition duration-200 ease-in-out disabled:bg-gray-400"
                    disabled={uploading}>
                    {uploading ? "Đang đăng tin..." : "Đăng Tin Ngay"}
                </button>
            </form>
        </div>
    );
}